<script>
  import { Analytics } from "./../../../../Controller/analytics/pedidos/pedidos.js";
  import {
    panelController,
    modalStore,
    messrest,
    updateService,
    updateD,
    modalS,
  } from "../../../../stores/service";
  import { user } from "../../../../stores/user";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { auth } from "../../../../firebase";
  import { createNewDate } from "../../../../Controller/APIs/date";
  import { modelValid } from "../../../../Models/modelSystemG.js";

  onMount(async () => {
    $panelController.viewEvaluacion.nav = false;
    $panelController.viewPerfil.nav = false;

    if (
      $panelController.service.service.mode == 1 &&
      !$panelController.viewMenu.menuService
    ) {
      $panelController.viewMenu.menuService = false;
      navigate("/pedido", { replace: true });
    }

    if (!$panelController.viewEvaluacion.status) {
      switch ($panelController.viewLogin.roluser) {
        case 1:
          begin(
            $panelController.service.listRatinggs[
              $panelController.viewEvaluacion.index[0]
            ].config.mode,
          );
          break;
        case 3:
          begin(
            $panelController.service.listRatinggs[
              $panelController.viewEvaluacion.index[0]
            ].config.mode,
          );
          break;

        default:
          alert(
            "valor desconocido --->",
            $panelController.viewEvaluacion.roluser,
          );
          break;
      }
    }
  });

  document.title = "Ratingg";

  function begin(opc) {
    $panelController.viewEvaluacion.controllers.btn[0].status = false;
    $panelController.viewEvaluacion.controllers.btn[1].status = false;
    $panelController.viewEvaluacion.controllers.inputs = [];
    $panelController.service.listRatinggs[
      $panelController.viewEvaluacion.index[0]
    ].rattings.forEach((item, index) => {
      $panelController.viewEvaluacion.controllers.inputs[index] = {
        active: false,
        value: "",
        valid: false,
      };
    });
    switch (opc) {
      case 1:
        $panelController.viewEvaluacion.controllers.inputs[0] = {
          active: true,
          value: "",
          valid: false,
        };
        break;
      case 2:
        $panelController.viewEvaluacion.controllers.inputs[0] = {
          active: true,
          value: "",
          valid: false,
        };
        break;
      case 3:
        $panelController.service.listRatinggs[
          $panelController.viewEvaluacion.index[0]
        ].rattings.forEach((item, index) => {
          $panelController.viewEvaluacion.controllers.inputs[index] = {
            active: true,
            value: "",
            valid: false,
          };
        });
        break;

      default:
        navigate("/main-ratinggs", { replace: true });
        break;
    }
    $panelController.viewCE.nav = false;
    $panelController.viewConfiguracion.nav = false;
    $panelController.viewMenu.nav = false;
    $panelController.viewLogin.nav = false;
    $panelController.viewMainRatinggs.nav = false;
    $panelController.viewOrdenar.nav = false;
    $panelController.viewDashboard.nav = false;
    $panelController.viewPanel.nav = false;
    $panelController.viewPerfil.nav = false;
    $panelController.viewSondeosPanel.nav = false;
    $panelController.viewMembresias.nav = false;

    $panelController.viewEvaluacion.status = true;
  }

  async function newRatting() {
    let mv = await modelValid({
      doc: "rdDocumentService",
    });
    if (mv.status == false) {
      return;
    }
    let date = await createNewDate("America/Mexico_City");
    if (!date.status) {
      return 0;
    }
    let rattingg =
      $panelController.service.listRatinggs[
        $panelController.viewEvaluacion.index[0]
      ].rattings;

    rattingg.forEach((value, index) => {
      rattingg[index].respuesta =
        $panelController.viewEvaluacion.controllers.inputs[index].value;
    });
    console.log(
      $panelController.service.listRatinggs[
        $panelController.viewEvaluacion.index[0]
      ].analytics.coleccion[$panelController.viewMenu.ind_user].rattinggs,
    );

    $panelController.service.listRatinggs[
      $panelController.viewEvaluacion.index[0]
    ].analytics.coleccion[$panelController.viewMenu.ind_user].rattinggs =
      rattingg;

    modelValid({
      doc: "updateService",
    });

    navigate("/final", { replace: true });
  }

  function controller(item) {
    switch (item) {
      case 1:
        /* save */
        newRatting();
        break;
      case 2:
        $panelController.viewEvaluacion.controllers.inputs.forEach(
          (item, index) => {
            if (item.valid) {
              if (
                index + 1 <
                $panelController.viewEvaluacion.controllers.inputs.length
              ) {
                $panelController.viewEvaluacion.controllers.inputs[
                  index + 1
                ].active = true;
                $panelController.viewEvaluacion.controllers.inputs[
                  index
                ].active = false;
              }
              $panelController.viewEvaluacion.controllers.btn[0].status = false;
              $panelController.viewEvaluacion.controllers.btn[1].status = false;
            }
          },
        );
        break;
      case 3:
        if (
          $panelController.service.listRatinggs[
            $panelController.viewEvaluacion.index[0]
          ].config.key[0]
        ) {
          begin(
            $panelController.service.listRatinggs[
              $panelController.viewEvaluacion.index[0]
            ].config.mode,
          );
        } else {
        }
        break;

      default:
        navigate("/main-ratinggs", { replace: true });
        break;
    }
  }

  function respuestas(item) {
    switch (item.tipo) {
      case 1:
        const respuestas = Array.isArray(
          $panelController.viewEvaluacion.controllers.inputs[item.index].value,
        )
          ? $panelController.viewEvaluacion.controllers.inputs[item.index].value
          : [
              $panelController.viewEvaluacion.controllers.inputs[item.index]
                .value,
            ];

        if (respuestas.length > 0) {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            true;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-success";
        } else {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            false;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-danger";
        }
        break;
      case 2:
        /* evaluacion rapida */
        if (
          $panelController.viewEvaluacion.controllers.inputs[item.index]
            .value >= 0
        ) {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            true;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-success";
        } else {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            false;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-danger";
        }
        break;
      case 3:
        if (
          $panelController.viewEvaluacion.controllers.inputs[item.index]
            .value >= 0
        ) {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            true;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-success";
        } else {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            false;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-danger";
        }
        break;
      case 4:
        const ep = /^[0-9\w'\-,.][^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,170}$/;
        if (
          ep.test(
            $panelController.viewEvaluacion.controllers.inputs[item.index]
              .value,
          )
        ) {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            true;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-success";
        } else {
          $panelController.viewEvaluacion.controllers.inputs[item.index].valid =
            false;
          $panelController.viewEvaluacion.controllers.inputs[
            item.index
          ].styletxt = "text-danger";
        }

        break;
      default:
        break;
    }

    switch (
      $panelController.service.listRatinggs[
        $panelController.viewEvaluacion.index[0]
      ].config.mode
    ) {
      case 1:
        /* Normal */
        $panelController.viewEvaluacion.controllers.inputs.forEach(
          (item, index) => {
            if (
              $panelController.viewEvaluacion.controllers.inputs[index].active
            ) {
              if (item.valid) {
                if (
                  index + 1 <
                  $panelController.viewEvaluacion.controllers.inputs.length
                ) {
                  $panelController.viewEvaluacion.controllers.btn[1].status = true;
                  $panelController.viewEvaluacion.controllers.btn[0].status = false;
                } else {
                  $panelController.viewEvaluacion.controllers.btn[0].status = true;
                  $panelController.viewEvaluacion.controllers.btn[1].status = false;
                }
              } else {
                $panelController.viewEvaluacion.controllers.btn[0].status = false;
                $panelController.viewEvaluacion.controllers.btn[1].status = false;
              }
            }
          },
        );
        break;
      case 2:
        /* Rapida */
        $panelController.viewEvaluacion.controllers.inputs.forEach(
          (dat, index) => {
            if (
              $panelController.viewEvaluacion.controllers.inputs[index].active
            ) {
              if (dat.valid) {
                if (index == 0) {
                  $modalStore.title = "Aviso";
                  $modalStore.ans = null;
                  $modalStore.opc = 45;
                  $modalStore.body = `Le gustaría participar en un prueba`;
                  $modalStore.opcS = "Si, quiero";
                  $modalStore.opcN = "No quiero ";
                  $modalStore.data = [];
                  $modalStore.mess = true;
                  $modalStore.open = true;
                }
                if (item.tipo == "2") {
                  controller(2);
                }
                if (
                  index + 1 <
                  $panelController.viewEvaluacion.controllers.inputs.length
                ) {
                  $panelController.viewEvaluacion.controllers.btn[1].status = true;
                  $panelController.viewEvaluacion.controllers.btn[0].status = false;
                } else {
                  $panelController.viewEvaluacion.controllers.btn[0].status = true;
                  $panelController.viewEvaluacion.controllers.btn[1].status = false;
                }
              } else {
                $panelController.viewEvaluacion.controllers.btn[0].status = false;
                $panelController.viewEvaluacion.controllers.btn[1].status = false;
              }
            }
          },
        );

        break;
      case 3:
        /* Cuestionario */
        $panelController.viewEvaluacion.controllers.btn[0].status = true;
        $panelController.viewEvaluacion.controllers.inputs.forEach((item) => {
          if (!item.valid) {
            $panelController.viewEvaluacion.controllers.btn[0].status = false;
          }
        });
        break;

      default:
        navigate("/main-ratinggs", { replace: true });
        break;
    }
  }

  function cerrarVentana() {
    auth.signOut();
    user.setUser(null);

    navigate("/", { replace: true });
  }

  function servAvan(status) {
    modal.ans = status;
    modal.open = false;
    modal.mess = status;
    if (status) {
      servic();
    }
    if (!status) {
      respuestas();
    }
  }

  const servic = () => {
    /*     
    console.log('modal.ans === true ',modal.ans === true ,'0 < $panelController.viewEvaluacion.controllers.inputs[index].value.length ',0 < $panelController.viewEvaluacion.controllers.inputs[index].value.length,'ind[0] < ind[1]',ind[0] < ind[1]); */
    if (modal.ans === true && ind[0] < ind[1]) {
      services = {};
      ind[0]++;
    }
  };

  $: {
    if ($modalStore.opc == 45 && $modalStore.ans != null) {
      if (!$modalStore.ans) {
        messrest();
        newRatting();
      }
    }
  }
</script>

<!-- {#if close}
  <h1>Gracias por participar :D</h1>

  <h2>La ventana se cerrara en ...{tiempoRestante}</h2>
{/if} -->

{#if $panelController.viewEvaluacion.status}
  <div class="col-12">
    <!-- Widget: user widget style 1 -->
    <div class="card card-widget widget-user shadow">
      <!-- Add the bg color to the header using any of the bg-* classes -->
      <div class="widget-user-header">
        <h3 class="widget-user-username">{$panelController.service.name}</h3>
        <h5 class="widget-user-desc">
          {$panelController.service.listRatinggs[
            $panelController.viewEvaluacion.index[0]
          ].config.name}
        </h5>
      </div>
      <div class="widget-user-image">
        <img
          class="img-circle elevation-2"
          src={$panelController.service.ico}
          alt={$panelController.service.ico}
        />
      </div>

      <div class="card-footer">
        <div class="row p-3">
          {#each $panelController.service.listRatinggs[$panelController.viewEvaluacion.index[0]].rattings as services, ind}
            {#if services.tipo == 1 && $panelController.viewEvaluacion.controllers.inputs[ind].active}
              <div class="question">
                <span class="number">{ind + 1}.</span>
                {services.pregunta}
              </div>
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value !== ""}
                <span class="text-success">
                  <!-- {#each $panelController.viewEvaluacion.controllers.inputs[ind].value as inner, index}
                    {$panelController.service.listRatinggs[
                      $panelController.viewEvaluacion.index[0]
                    ].rattings[ind].checks[0].checks[inner].contenido + " "}
                  {/each} -->
                </span>
              {/if}
              <div class="options">
                <div class="form-group clearfix">
                  {#if services.tipo == 1 && services.checkboxOpc == 2}
                    {#each services.checks as check, indx}
                      <div class="icheck-primary d-inline">
                        <input
                          type="radio"
                          id="radioPrimary{indx + 1}{ind + 1}"
                          bind:group={
                            $panelController.viewEvaluacion.controllers.inputs[
                              ind
                            ].value
                          }
                          value={indx}
                          name="r{ind + 1}{ind + 1}"
                          on:change={() =>
                            respuestas({
                              index: ind,
                              tipo: services.tipo,
                            })}
                        />
                        <label for="radioPrimary{indx + 1}{ind + 1}">
                          {check}
                        </label>
                      </div>
                      <br />
                    {/each}
                  {:else}
                    {#each services.checks as check, indx}
                      <div class="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="checkboxPrimary{indx + 1}"
                          bind:group={
                            $panelController.viewEvaluacion.controllers.inputs[
                              ind
                            ].value
                          }
                          value={indx}
                          name="r1"
                          on:change={() =>
                            respuestas({
                              index: ind,
                              tipo: services.tipo,
                            })}
                        />
                        <label for="checkboxPrimary{indx + 1}">
                          {check}
                        </label>
                      </div>
                      <br />
                    {/each}
                  {/if}
                </div>
              </div>
            {/if}

            {#if services.tipo == 4 && $panelController.viewEvaluacion.controllers.inputs[ind].active}
              <form>
                <div class="mb-3">
                  <label for="validationTextarea"
                    >{ind + 1}. {services.pregunta}</label
                  >
                  {#if $panelController.viewEvaluacion.controllers.inputs[ind].value !== ""}
                    <span
                      class={$panelController.viewEvaluacion.controllers.inputs[
                        ind
                      ].styletxt}
                    ></span>
                  {/if}
                  <textarea
                    class="form-control"
                    bind:value={
                      $panelController.viewEvaluacion.controllers.inputs[ind]
                        .value
                    }
                    on:input={() =>
                      respuestas({
                        index: ind,
                        tipo: services.tipo,
                      })}
                  />
                  {#if $panelController.viewEvaluacion.controllers.inputs[ind].value !== ""}
                    {#if $panelController.viewEvaluacion.controllers.inputs[ind].valid}
                      <p style="color: green">Valido</p>
                    {:else}
                      <p style="color: red">No valido</p>
                    {/if}
                  {/if}
                </div>
              </form>
            {/if}

            {#if services.tipo == 2 && $panelController.viewEvaluacion.controllers.inputs[ind].active}
              <div class="question">
                <span class="number">{ind + 1}.</span>
                {services.pregunta}
              </div>

              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 0}
                <span class="text-danger"> Malo</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 1}
                <span class="text-secondary"> Regular</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 2}
                <span class="text-success"> Bueno</span>
              {/if}

              <div class="row d.flex align-items-center justify-content-center">
                <div class="col-10 p-2">
                  <button
                    type="button"
                    class="btn btn-block btn-lg text-sm text-md-lg btnsystem"
                    data-toggle="modal"
                    data-target={services.nPregunta == 1
                      ? `#modal-default`
                      : ``}
                    style="background-color:green"
                    on:click={() =>
                      ($panelController.viewEvaluacion.controllers.inputs[
                        ind
                      ].value = 2)}
                    on:click={() =>
                      respuestas({
                        index: ind,
                        tipo: services.tipo,
                      })}>Bueno</button
                  >
                </div>
                <div class="col-10 p-2">
                  <button
                    type="button"
                    class="btn btn-block btn-lg text-sm text-md-lg btnsystem"
                    data-toggle="modal"
                    data-target={services.nPregunta == 1
                      ? `#modal-default`
                      : ``}
                    style="background-color:yellow;color:black;"
                    on:click={() =>
                      ($panelController.viewEvaluacion.controllers.inputs[
                        ind
                      ].value = 1)}
                    on:click={() =>
                      respuestas({
                        index: ind,
                        tipo: services.tipo,
                      })}>Regular</button
                  >
                </div>
                <div class="col-10 p-2">
                  <button
                    type="button"
                    class="btn btn-block btn-lg text-sm text-md-lg btnsystem"
                    data-toggle="modal"
                    data-target={services.nPregunta == 1
                      ? `#modal-default`
                      : ``}
                    style="background-color:red"
                    on:click={() =>
                      ($panelController.viewEvaluacion.controllers.inputs[
                        ind
                      ].value = 0)}
                    on:click={() =>
                      respuestas({
                        index: ind,
                        tipo: services.tipo,
                      })}>Malo</button
                  >
                </div>
              </div>
            {/if}

            {#if services.tipo == 3 && $panelController.viewEvaluacion.controllers.inputs[ind].active}
              <div class="question">
                <span class="number">{ind + 1}.</span>
                {services.pregunta}
              </div>

              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 0}
                <span class="text-danger"> Muy Malo</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 1}
                <span class="text-warning"> Malo</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 2}
                <span class="text-secondary"> Regular</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 3}
                <span class="text-primary"> Bueno</span>
              {/if}
              {#if $panelController.viewEvaluacion.controllers.inputs[ind].value === 4}
                <span class="text-success"> Muy Bueno</span>
              {/if}
              <!-- <div>{cambiarValor(rating.valor)}</div> -->
              <div class="col-12">
                <input
                  type="range"
                  min="0"
                  max="4"
                  step="1"
                  class="custom-range custom-range-teal"
                  id="customRange3"
                  on:change={() =>
                    respuestas({
                      index: ind,
                      tipo: services.tipo,
                    })}
                  bind:value={
                    $panelController.viewEvaluacion.controllers.inputs[ind]
                      .value
                  }
                />
              </div>
            {/if}
          {/each}
        </div>
        {#each $panelController.viewEvaluacion.controllers.btn as item}
          {#if item.status}
            <div class="col-12 p-2">
              <button
                class="btn {item.style} btn-block btn-lg text-sm text-md-lg btnsystem"
                on:click|preventDefault={() => controller(item.opc)}
                >{item.text}</button
              >
            </div>
          {/if}
        {/each}
      </div>
    </div>
    <!-- /.widget-user -->
  </div>
{/if}

<style>
  .modal {
    display: block;
  }
  .question {
    margin: 20px 0;
    font-weight: bold;
  }
  .options {
    margin-left: 20px;
  }

  .option {
    margin: 10px 0;
  }
  .number {
    font-size: 1.2em;
    margin-right: 10px;
  }
  .checkbox-option {
    display: flex;
    align-items: center;
  }
  .checkbox-input {
    margin-right: 10px;
  }
  .btnsystem {
    /* background-color:rgb(218, 92, 56); */
    border-radius: 25px;
    color: aliceblue;
    font-size: 24px;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .widget-user-header {
    background-color: rgb(218, 92, 56);
    color: aliceblue;
  }
  h3 {
    text-align: center;
  }
</style>
